function apresentarData(valor) {
    if (valor) {
        return valor.toString().substring(0, 10);
    }
    return
}

export default apresentarData;